import { render, staticRenderFns } from "./ArvMenu.vue?vue&type=template&id=3f99203a&scoped=true&"
import script from "./ArvMenu.vue?vue&type=script&lang=js&"
export * from "./ArvMenu.vue?vue&type=script&lang=js&"
import style0 from "./ArvMenu.vue?vue&type=style&index=0&id=3f99203a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f99203a",
  null
  
)

/* custom blocks */
import block0 from "./ArvMenu.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports